import styled from "styled-components"
import { TABLET_MAX_WIDTH, MOBILE_MIN_WIDTH } from "@constants"

export const StyledProudItemsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  div[class~="gatsby-image-wrapper"] {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 23px;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    display: grid;
    grid-template-columns: repeat(2, 0.4fr);
    row-gap: 10px;
  }
`;